import { HtmlResize } from "@logicflow/extension";

export default function registerPosition (lf) {
  lf.register('warehouse', () => {
    class ConnectNode extends  HtmlResize.view {

      setHtml(rootEl) {
        const {
          properties: { scale }
        } = this.props.model;

           rootEl.innerHTML = "";
           rootEl.setAttribute("class", "table-container ");
           rootEl.style.background="#ffffff"
           rootEl.style.border="1px solid #f1a131"
        const { properties ,text} = this.props.model;
        const container = document.createElement("div");
        container.style.height="100%"

        const tableNameElement = document.createElement("div");
        tableNameElement.innerText = text.value;
        tableNameElement.className = "table-name";
        container.appendChild(tableNameElement);
        const fragment = document.createElement("ul");// document.createDocumentFragment();
        fragment.className="ul_field";
        // fragment.style.width="300px";
        for (let i = 0; i < scale; i++) {
          // const itemLi = document.createElement("li");
          const itemElement = document.createElement("li");
          itemElement.className = "table-feild";
          const itemKey = document.createElement("span");
          itemKey.innerText = "甲类仓库一";

          itemKey.className = "feild-name";

          const stepElement = document.createElement("div");
          stepElement.className="step";
          const stepLeft = document.createElement("div");
          stepLeft.className="left "+(i==0?"full-right":"")+(i>3?"full-left":"");
          stepLeft.setAttribute("style", "width:"+(i*30)+"%");

          stepLeft.setAttribute(":class", "full-right");
          const stepRight = document.createElement("div");
          stepRight.className=i>2?"full-left":"right ";

          const stepText = document.createElement("div");
          stepText.className="steptext";
          stepText.innerText="10T/2T";
          // stepRight.setAttribute("style", "{width:"+(100-i*30)+"10%} ");
          stepElement.appendChild(stepLeft);
          stepElement.appendChild(stepRight);
          stepElement.appendChild(stepText);

          itemElement.appendChild(itemKey);

          itemElement.appendChild(stepElement);

          fragment.appendChild(itemElement);
        }
        container.appendChild(fragment);
        rootEl.appendChild(container);


      }
    }
    class ConnectNodeModel extends HtmlResize.model {

      initNodeData(data) {
        super.initNodeData(data);
        this.width = 150;
        this.height = 150;
        const properties = this.getProperties()

      }
      getNodeStyle() {
        const style = super.getNodeStyle();

        style.fill = "#f1a131";
        style.stroke="#ececec";
        style.strokeWidth = 5;
          style.strokeDasharray = "3 3";
          if (this.isSelected) {
              style.stroke = "rgb(124, 15, 255)";
          }
        return style;
      }
      getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.stroke = "transparent";
        style.fill = "none";
        style.hover.stroke = "transparent";
        return style;
      }
    }
    return {
      view: ConnectNode,
      model: ConnectNodeModel
    }
  })
}